import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';

import { Observable } from 'rxjs';

import { Labels, LanguageConfig } from '../../app.models';
import { selectLocale } from 'src/app/store/query-params';
import { languageList } from '../../config/app-config';
import { UtilsService } from '../../services/utils.service';
import { GetOndemandLangLabels } from '../../store/labels/labels.actions';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent implements OnInit {
  private _languages: LanguageConfig[] =
    this.sortLanguagesByCMSKey(languageList);
  private _labels: Labels;
  public currentLangCode: string;
  public currentLangLabel: string;
  isMobile$: Observable<boolean>;
  isMenuActive: boolean = false;

  @Input() public set languages(langList: LanguageConfig[]) {
    let sortedLanguageList = this.sortLanguagesByCMSKey(langList);
    this._languages = !!langList[0]?.code ? sortedLanguageList : languageList;
  }
  public get languages() {
    return this._languages;
  }

  @Input() public set labels(labels: Labels) {
    this._labels = labels;
  }
  public get labels() {
    return this._labels;
  }

  constructor(
    private cookieService: CookieService,
    private utilService: UtilsService,
    private store: Store<any>
  ) {}

  ngOnInit(): void {
    this.store.select(selectLocale).subscribe((locale) => {
      this.currentLangCode = locale;
    });
    this.setLanguageCode(this.currentLangCode);
    this.isMobile$ = this.utilService.isMobile;
  }

  switchLanguage(languageCode: string): void {
    if (languageCode === this.cookieService.get('langCode')) {
      return;
    }
    this.store.dispatch(
      GetOndemandLangLabels({ getLabelsRequest: { locale: languageCode } })
    );
  }

  getLanguageCode() {
    const cookieLangCode = this.cookieService.get('langCode');
    const langKey = this.getLanguageByCode(cookieLangCode).cmsKey;
    const langLabel = this.labels.stellar.languageSelector[langKey];
    return langLabel?.substring(0, 3) || 'Eng';
  }

  getLanguageByCode(langcode: string): LanguageConfig {
    return (
      this._languages.find((config) => config.code === langcode) || {
        code: 'en-US',
        cmsKey: 'ENGLISH',
      }
    );
  }

  currentLanguageLabel(): string {
    const langKey = this.getLanguageByCode(this.currentLangCode).cmsKey;
    const langLabel = this.labels.stellar.languageSelector[langKey];
    return langLabel.match(/\S+/)[0].trim();
  }

  setLanguageCode(langCode: string) {
    const langKey = this.getLanguageByCode(langCode).cmsKey;
    const langLabel = this.labels.stellar.languageSelector[langKey];
    this.currentLangLabel = langLabel.match(/\S+/)[0].trim();
  }

  sortLanguagesByCMSKey(listOfLanguages: LanguageConfig[]): LanguageConfig[] {
    let sortedLanguageList = [...listOfLanguages];
    sortedLanguageList = sortedLanguageList.sort((a, b) => {
      const itemA = a.cmsKey;
      const itemB = b.cmsKey;
      if (itemA < itemB) {
        return -1;
      }
      if (itemA > itemB) {
        return 1;
      }
      return 0;
    });
    return sortedLanguageList;
  }
}
